let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("31iUf")).then(() => parcelRequire('1gGyY'));